var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"suspicious-group-join-investigator"},[_c('div',{staticClass:"title"},[_vm._v("היי "+_vm._s(_vm.householdName)+",")]),_vm._v(" "),(_vm.reportApproved)?_c('suspicious-group-join-reported'):_c('suspicious-group-join-question')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19ea8b1c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/responsive-pages/authenticated/suspicious-group-join/SuspiciousGroupJoinInvestigator.vue
// module id = null
// module chunks = 